import { Features, useFeatureFlags } from '@/shared/ui';
import { useNavigationVersion } from '../../model/useNavigationVersion';
import { NavigationDrawerV1 } from '../NavigationDrawerV1/NavigationDrawerV1';
import { NavigationDrawerV2 } from '../NavigationDrawerV2';

export function NavigationDrawer() {
  const { isFeatureAvailable } = useFeatureFlags();
  const { version } = useNavigationVersion();

  if (version === 'v1' && isFeatureAvailable(Features.navigationV1Switcher)) {
    return <NavigationDrawerV1 />;
  }

  return <NavigationDrawerV2 />;
}
